import { Injectable } from '@angular/core';
import { CartConfigService, CartService, CartRow, BaseViewConfigService, ProductAssortmentParentService } from 'gung-standard';
import { ListLayoutMultipleComponent, ListLayout } from 'gung-list';
import { TyloCartListComponent } from '../components/checkout/sweden/tylo-cart-list/tylo-cart-list.component';
import { TyloJeevesSalesCartListComponent } from '../components/checkout/sweden/tylo-jeeves-sales-cart-list/tylo-jeeves-sales-cart-list.component';

@Injectable({
  providedIn: 'root'
})
export class TyloCartConfigService extends CartConfigService {
  constructor(
    protected cartService: CartService,
    protected baseViewConfigService: BaseViewConfigService,
    protected productAssortmentParentService: ProductAssortmentParentService
    ) {
    super(cartService, baseViewConfigService, productAssortmentParentService);
  }

  getLayouts(): ListLayout<CartRow>[] {
    return [
      {
        getIconClass: () => '',
        getName: () => 'Cart grid',
        getListItemComponent: () => TyloJeevesSalesCartListComponent,
        getListLayoutComponent: () => ListLayoutMultipleComponent
      }
    ];
  }
}
